const naturalSort = (a, b) => {
  if ((a === null || a === undefined) && (b === null || b === undefined)) {
    return 0
  }

  if (a === null || a === undefined) {
    return 1
  }

  if (b === null || b === undefined) {
    return -1
  }

  return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' })
}

export default naturalSort
